import React, { createContext, useContext, useState } from "react";
import { STRINGS } from "@/data/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("gkn_lang") || "en");

  const toggle = () => {
    const next = lang === "en" ? "kn" : "en";
    setLang(next);
    localStorage.setItem("gkn_lang", next);
  };

  // pick a localized field from an object: t(obj, "heroTitle") -> heroTitle_kn when available
  const t = (obj, key) => {
    if (!obj) return "";
    if (lang === "kn" && obj[`${key}_kn`]) return obj[`${key}_kn`];
    return obj[key] || "";
  };

  // static UI string lookup: tr("cta.submitIssue")
  const tr = (key) => {
    const entry = STRINGS[key];
    if (!entry) return key;
    return lang === "kn" ? entry.kn || entry.en : entry.en;
  };

  return (
    <LanguageContext.Provider value={{ lang, toggle, t, tr }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
